/**
 * Meta Pixel helpers for the marketing site.
 * gatsby-ssr loads/inits the pixel on eligible routes; PageView is always
 * fired from gatsby-browser onRouteUpdate (including the first load) so Meta
 * Pixel Helper and other late listeners observe it. Also covers sessions that
 * start on a credential-bearing route and later navigate to an eligible one.
 */

function getMetaPixelId() {
  return process.env.GATSBY_META_PIXEL_ID
}

function shouldLoadMetaPixel() {
  return (
    typeof window !== "undefined" &&
    // Homepage embeds same-origin pages (/tenderid-demo, /tn/...) in iframes.
    // Those pages also get this bootstrap; Meta Pixel Helper often fails when
    // nested frames init the pixel. Only track in the top window.
    window.self === window.top &&
    process.env.NODE_ENV === "production" &&
    Boolean(getMetaPixelId())
  )
}

/**
 * Ensure window.fbq is initialized. Safe to call repeatedly.
 * Returns true when fbq is available for tracking.
 */
export function ensureMetaPixel() {
  if (!shouldLoadMetaPixel()) return false
  if (typeof window.fbq === "function") return true

  const pixelId = getMetaPixelId()
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = "2.0"
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(
    window,
    document,
    "script",
    "https://connect.facebook.net/en_US/fbevents.js"
  )
  /* eslint-enable */
  window.fbq("init", pixelId)
  return typeof window.fbq === "function"
}

/** Track a PageView, initializing the pixel first if needed. */
export function trackMetaPageView() {
  if (!ensureMetaPixel()) return
  window.fbq("track", "PageView")
}
